/**
 * @generated SignedSource<<ead3d3ce73aacd145df9dd052cd6e0df>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type MoveBankTransactionRuleInput = {
  id: string;
  position: number;
};
export type ConfigurationBankTransactionRulesViewMoveMutation$variables = {
  input: MoveBankTransactionRuleInput;
};
export type ConfigurationBankTransactionRulesViewMoveMutation$data = {
  readonly moveBankTransactionRule: ReadonlyArray<{
    readonly id: string;
    readonly position: number;
  }>;
};
export type ConfigurationBankTransactionRulesViewMoveMutation = {
  response: ConfigurationBankTransactionRulesViewMoveMutation$data;
  variables: ConfigurationBankTransactionRulesViewMoveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "BankTransactionRule",
    "kind": "LinkedField",
    "name": "moveBankTransactionRule",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "position",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ConfigurationBankTransactionRulesViewMoveMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ConfigurationBankTransactionRulesViewMoveMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "505227b6dd5dece0decbd7e3d1103d21",
    "id": null,
    "metadata": {},
    "name": "ConfigurationBankTransactionRulesViewMoveMutation",
    "operationKind": "mutation",
    "text": "mutation ConfigurationBankTransactionRulesViewMoveMutation(\n  $input: MoveBankTransactionRuleInput!\n) {\n  moveBankTransactionRule(input: $input) {\n    id\n    position\n  }\n}\n"
  }
};
})();

(node as any).hash = "33e4d39aefc269fd7a854c5082c9de4b";

export default node;
